<!-- Not authorized-->
<div class="misc-wrapper">
  <a
    class="brand-logo d-none d-lg-flex"
    routerLink="/">
    <img
      [src]="logoService.logoPath"
      alt="brand-logo"
      height="75px" />
  </a>
  <div class="misc-inner p-2 p-sm-3">
    <div class="w-100 text-center">
      <h2 class="mb-1">Hier dürfen Sie leider nicht hin! 🔐</h2>
      <p class="mb-2">Bitte kontaktieren Sie den Administrator, falls Sie hier Zugriff benötigen.</p>
      <button
        class="btn btn-primary mb-2 btn-sm-block"
        rippleEffect
        routerLink="/">
        Zurück zum Startbildschirm
      </button>
      <img
        [src]="
          coreConfig.layout.skin === 'dark'
            ? 'assets/images/pages/not-authorized-dark.svg'
            : 'assets/images/pages/not-authorized.svg'
        "
        alt="Not authorized page"
        class="img-fluid" />
    </div>
  </div>
</div>
<!-- / Not authorized-->
